/**
 * Oversee GPS tracking portal integration.
 * The WOSS API /getGPSData often returns {} because overseetracking.com
 * serves an HTML web app, not JSON — opening the portal URL in the browser works.
 */

export function getOverseeTrackingUrl(systemNo) {
  const base = 'https://www.overseetracking.com';
  if (!systemNo) {
    return `${base}/singlemonitor/main.aspx`;
  }
  return `${base}?SystemNo=${encodeURIComponent(String(systemNo).trim())}`;
}

export function openOverseeTrackingPortal(systemNo) {
  window.open(getOverseeTrackingUrl(systemNo), '_blank', 'noopener,noreferrer');
}

/**
 * Returns first GPS record if /getGPSData returns embeddable JSON; otherwise null.
 */
export function parseGpsApiPayload(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  if (
    payload.status === 'success' &&
    Array.isArray(payload.data) &&
    payload.data.length > 0
  ) {
    return payload.data[0];
  }

  if (Array.isArray(payload) && payload.length > 0) {
    return payload[0];
  }

  if (payload.Latitude != null && payload.Longitude != null) {
    return payload;
  }

  return null;
}

export async function fetchEmbeddedGpsData(axiosInstance, systemNo) {
  try {
    const response = await axiosInstance.get('/getGPSData', {
      params: { SystemNo: systemNo },
    });
    return parseGpsApiPayload(response.data);
  } catch (error) {
    console.error('getGPSData request failed:', error);
    return null;
  }
}

/**
 * Try embedded map data from API; if unavailable, open Oversee portal (same as direct URL).
 */
export async function launchGpsTracking(vm, axiosInstance, systemNo) {
  const trimmed = systemNo != null ? String(systemNo).trim() : '';

  if (!trimmed) {
    return {
      ok: false,
      error: 'System No is not available in WOSS System.',
    };
  }

  const embedded = await fetchEmbeddedGpsData(axiosInstance, trimmed);
  if (embedded) {
    return {
      ok: true,
      mode: 'embedded',
      gpsData: embedded,
      systemNo: trimmed,
    };
  }

  openOverseeTrackingPortal(trimmed);
  vm.$bvToast.toast(
    'Opening Oversee GPS tracking portal for this vehicle.',
    {
      title: 'GPS Tracking',
      variant: 'info',
      solid: true,
      autoHideDelay: 6000,
    }
  );

  return {
    ok: true,
    mode: 'external',
    systemNo: trimmed,
  };
}
